'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WarningIconIcon = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../lib/Icon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WarningIconIcon = exports.WarningIconIcon = function WarningIconIcon(props) {
  var _prepareProps = (0, _Icon.prepareProps)(props),
      title = _prepareProps.title,
      iconProps = _prepareProps.iconProps;

  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, iconProps, { 'aria-labelledby': 'title-5bf8x4h' }),
    _react2.default.createElement(
      'title',
      { id: 'title-5bf8x4h' },
      title
    ),
    _react2.default.createElement('path', { d: 'M12.938 4.967l7.124 13.458c.516.974.045 1.771-1.057 1.771H4.995c-1.102 0-1.575-.793-1.057-1.771l7.124-13.458c.516-.974 1.358-.978 1.876 0zM12 15a1 1 0 0 0 1-1V9a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2z', fill: 'currentColor', fillRule: 'evenodd', role: 'presentation' })
  );
};
exports.default = (0, _Icon.iconConstructor)('WarningIcon', WarningIconIcon);


//////////////////
// WEBPACK FOOTER
// ../field-text/~/@atlaskit/icon/glyph/warning.js
// module id = 462
// module chunks = 0